<template>
  <vue-ellipse-progress
    reverse
    :thickness="8"
    line="square"
    emptyThickness="10%"
    :color="data === 0 ? 'red' : data > 80 ? 'green' : 'orange'"
    :size="80"
    :emptyColor="
      data === 0 ? '#ff000033' : data > 80 ? '#00800033' : '#e58e2833'
    "
    :progress="data"
    :loading="loading"
    ><span
      :style="
        data === 0 ? 'color: red' : data > 80 ? 'color: green' : 'color: orange'
      "
      >{{ data }}%</span
    ></vue-ellipse-progress
  >
</template>
<script>
import { VueEllipseProgress } from "vue-ellipse-progress";
export default {
  props: {
    data: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    VueEllipseProgress,
  },
};
</script>
